export default __webpack_public_path__ + "img/user.fbfe03c2.png";